import { TD_MAP_KEY } from "@/utils/config";

const normalizeTdApiLang = (lang) => (lang === "en" ? "en" : "zh_cn");

const tdApiLangMatches = (loaded, needed) =>
  normalizeTdApiLang(loaded) === normalizeTdApiLang(needed);

const parseTiandituLangFromScriptSrc = (src) => {
  if (!src) return "zh_cn";
  try {
    const url = new URL(
      src,
      typeof location !== "undefined" ? location.href : undefined
    );
    return url.searchParams.get("lang") || "zh_cn";
  } catch {
    return "zh_cn";
  }
};

const clearTiandituRuntime = () => {
  document
    .querySelectorAll('script[src*="api.tianditu.gov.cn/api"]')
    .forEach((el) => {
      el.remove();
    });
  try {
    delete window.T;
  } catch (e) {
    window.T = undefined;
  }
  try {
    delete window.__TIANDITU_API_LANG__;
  } catch (e) {
    window.__TIANDITU_API_LANG__ = undefined;
  }
};

/** 加载天地图 JS API，语言不一致时会重新拉取脚本 */
export const loadTiandituApi = (lang = "zh_cn") =>
  new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("Tianditu API requires browser environment"));
      return;
    }

    const needLang = normalizeTdApiLang(lang);
    const getMarkedLoadedLang = () => {
      if (typeof window.__TIANDITU_API_LANG__ === "string") {
        return window.__TIANDITU_API_LANG__;
      }
      const el = document.querySelector(
        'script[src*="api.tianditu.gov.cn/api"]'
      );
      if (el?.src) return parseTiandituLangFromScriptSrc(el.src);
      if (window.T) return "zh_cn";
      return null;
    };

    const finish = () => {
      if (window.T) {
        resolve(window.T);
        return;
      }
      reject(new Error("Tianditu API failed to initialize"));
    };

    const loadedMark = getMarkedLoadedLang();
    if (
      window.T &&
      loadedMark != null &&
      tdApiLangMatches(loadedMark, needLang)
    ) {
      finish();
      return;
    }

    if (
      window.T ||
      document.querySelector('script[src*="api.tianditu.gov.cn/api"]')
    ) {
      clearTiandituRuntime();
    }

    const script = document.createElement("script");
    script.src = `https://api.tianditu.gov.cn/api?v=4.0&lang=${encodeURIComponent(
      needLang
    )}&tk=${TD_MAP_KEY}`;
    script.async = true;
    script.addEventListener("load", () => {
      window.__TIANDITU_API_LANG__ = needLang;
      finish();
    });
    script.addEventListener("error", () => {
      reject(new Error("Tianditu script load error"));
    });
    document.body.appendChild(script);
  });
